import { Injectable } from '@angular/core';
import { Menu, SubMenu } from './menu-models';

export enum UserRoles {
  ADMIN = 'admin',
  COMPANY = 'company',
  ACCOUNTANT = 'accountant',
  CREDENTIAL = 'credential',
  FULLACCESS = 'company',
  DISPATCHER = 'dispatcher',

  DISPATCHER_MNGR = 'mdispatcher',
  DISPATCHER_RMNGR = 'rdispatcher',
  CALL_CENTER_REP = 'rcallcenter',
  CALL_CENTER_MNGR = 'mcallcenter',
}

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  menus = {};
  userRole;
  isFarmout = false;

  constructor() { }

  addMenu(menu: Menu): void {
    if (this.canView(menu.roles)) {
      this.menus[menu.key] = menu;
    }
  }

  getAssignedSubMenu(role) {
    let subMenus = [
      {
        name: "All",
        value: "all",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Unassigned",
        value: "unassigned",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Assigned",
        value: "hanging",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "In Progress",
        value: "inprogress",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Cancelled",
        value: "cancelled",
        roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Archived",
        value: "archived",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Completed",
        value: "completed",
        roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      }
    ];
    let roleSpecificMenus = [];

    for (let i = 0; i < subMenus.length; i++) {
      if (subMenus[i].roles.includes(role)) {
        roleSpecificMenus.push(subMenus[i]);
      }
    }
    return roleSpecificMenus;
  }
  getTripReportSubMenu(role) {
    let subMenus = [
      {
        name: "All",
        value: "all",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Unassigned",
        value: "unassigned",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Assigned",
        value: "hanging",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "In Progress",
        value: "inprogress",
        roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Cancelled",
        value: "cancelled",
        roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      },
      {
        name: "Completed",
        value: "completed",
        roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
      }
    ];
    let roleSpecificMenus = [];

    for (let i = 0; i < subMenus.length; i++) {
      if (subMenus[i].roles.includes(role)) {
        roleSpecificMenus.push(subMenus[i]);
      }
    }
    return roleSpecificMenus;
  }


  addSubMenu(key: string, subMenu: SubMenu) {
    if ((this.menus[key] && this.canView(subMenu.roles))) {
      const subMenus = this.menus[key].subMenus;
      if (!subMenus) {
        this.menus[key].subMenus = [];
      }
      this.menus[key].subMenus.push(subMenu);
    }
  }

  getMenu(userRole, user?): object {
    this.menus = {};
    if (user && user.hasOwnProperty('isFarmout')) {
      this.isFarmout = user.isFarmout;
    }
    this.userRole = userRole;
    this.addMenus();
    let finalMenu
    if (user) {
      finalMenu = this.skipMenu(this.menus, user);
    } else {
      finalMenu = this.menus;
    }
    return finalMenu;
  }

  skipMenu(menuConfig: any, user: any) {
    return Object.entries(menuConfig).reduce((acc: any, [key, menu]: any) => {
      acc[key] = !menu.subMenus
        ? menu
        : {
          ...menu,
          subMenus: menu.subMenus.filter((subMenu: any) => {
            // skip Push to Talk if flag is false
            if (
              subMenu.url === 'support/push-to-talk' &&
              !user.allowPushToTalk
            ) {
              return false;
            }

            else if (subMenu.title === 'Auto Planner' && !user.allowAutoDispatch) {
              return false;
            }

            return true;
          })
        };

      return acc;
    }, {});
  }


  addMenus() {
    // Dashboard
    this.addMenu({
      title: "Dashboard",
      url: "dashboard",
      icon: this.getIcon("home"),
      key: "dashboard",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR],
    });

    // operations
    this.addMenu({
      title: "Operations",
      url: "operations",
      icon: this.getIcon("operations"),
      key: "operations",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR]
    });


    // Trips
    this.addMenu({
      title: "Trips",
      url: "trips",
      icon: this.getIcon("trips"),
      key: "trips",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP],
    });

    this.addSubMenu('trips', {
      title: "Trips",
      url: "trips",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    this.addSubMenu('trips', {
      title: "Offered",
      url: "trips/offered",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    this.addSubMenu('trips', {
      title: "Drivers Load",
      url: "trips/drivers-load",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });
    this.addSubMenu('trips', {
      title: "Buckets",
      url: "trips/buckets",
      position: 4,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    // this.addSubMenu('trips', {
    //   title: "Late Forecast",
    //   url: "trips/forecast",
    //   position: 5,
    //   roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    // });

    this.addSubMenu('trips', {
      title: "Standing Orders",
      url: "trips/standing-orders",
      position: 6,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    // this.addSubMenu('trips', {
    //   title: "Routing",
    //   url: "trips/grouping",
    //   position: 7,
    //   roles: [UserRoles.COMPANY]
    // });

    this.addSubMenu('trips', {
      title: "Trip Sheet",
      url: "trips/trip-sheet",
      position: 8,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    this.addSubMenu('trips', {
      title: "Dirt Road",
      url: "trips/dirt-road",
      position: 9,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });

    this.addSubMenu('trips', {
      title: "New Trip",
      url: "trips/new",
      position: 10,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP]
    });


    // Planenr
    this.addMenu({
      title: "Planner",
      url: "planner",
      icon: this.getIcon("planner"),
      key: "planner",
      position: 4,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP],
    });

    this.addSubMenu('planner', {
      title: "Playground",
      url: "planner/playground",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('planner', {
      title: "Schedule",
      url: "planner/schedule",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('planner', {
      title: "Mapper",
      url: "planner/mapper",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('planner', {
      title: "Template",
      url: "planner/template",
      position: 4,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });


    this.addSubMenu('planner', {
      title: "Holidays",
      url: "planner/holidays",
      position: 3,
      roles: [UserRoles.FULLACCESS],
    });

    this.addSubMenu('planner', {
      title: "Violation Sets",
      url: "planner/violation",
      position: 5,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('planner', {
      title: "Auto Planner",
      url: "planner/playground",
      position: 6,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    // farmout
    if (this.isFarmout) {
      this.addMenu({
        title: "Farmout",
        url: "farmout",
        icon: this.getIcon("farmout"),
        key: "farmout",
        position: 3.05,
        roles: [UserRoles.COMPANY, UserRoles.FULLACCESS],
      });
    }

    // Manifest
    this.addMenu({
      title: "Manifest",
      url: "manifest",
      icon: this.getIcon("manifest"),
      key: "manifest",
      position: 3.1,
      roles: [UserRoles.ACCOUNTANT, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR, UserRoles.CALL_CENTER_REP, UserRoles.DISPATCHER],
    });

    // Credentails
    this.addMenu({
      title: "Profiling",
      url: "credentialing",
      icon: this.getIcon("credentialing"),
      key: "credentialing",
      position: 3.2,
      roles: [UserRoles.ADMIN, UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });



    this.addSubMenu('credentialing', {
      title: "Drivers",
      url: "credentialing/drivers",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('credentialing', {
      title: "Staff",
      url: "credentialing/staff",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS]
    });

    this.addSubMenu('credentialing', {
      title: "Members",
      url: "credentialing/members",
      position: 4,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('credentialing', {
      title: "Funding Sources",
      url: "credentialing/fundingsource",
      position: 5,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('credentialing', {
      title: "Credentials",
      url: "credentialing/credential-drivers",
      position: 5.1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('credentialing', {
      title: "Companies",
      url: "credentialing/companies",
      position: 4,
      roles: [UserRoles.ADMIN]
    });

    this.addSubMenu('credentialing', {
      title: "Quarters",
      url: "credentialing/quarterpanels",
      position: 5,
      roles: [UserRoles.ADMIN]
    });

    // Credentails
    this.addMenu({
      title: "Fleet",
      url: "fleet",
      icon: this.getIcon("fleet"),
      key: "fleet",
      position: 4.0,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('fleet', {
      title: "Vehicles",
      url: "fleet/vehicles",
      position: 0,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu("fleet", {
      title: "Level of Service",
      url: "fleet/levelofservice",
      position: 1,
      // roles: [UserRoles.COMPANY, UserRoles.FULLACCESS]
      roles: [UserRoles.FULLACCESS]
    });

    this.addSubMenu("fleet", {
      title: "Space Types",
      url: "fleet/spaceTypes",
      position: 2,
      // roles: [UserRoles.COMPANY, UserRoles.FULLACCESS]
      roles: [UserRoles.FULLACCESS]
    });

    this.addSubMenu("fleet", {
      title: "Equipments",
      url: "fleet/equipment",
      position: 3,
      roles: [UserRoles.FULLACCESS]
    });


    this.addSubMenu('fleet', {
      title: "Service Areas",
      url: "fleet/service-areas",
      position: 4,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    this.addSubMenu('fleet', {
      title: "Equipment Planning",
      url: "fleet/equipment-planning",
      position: 6,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    });

    // // CheckList
    // this.addMenu({
    //   title: "CheckList",
    //   url: "checklist",
    //   icon: this.getIcon("checklist"),
    //   key: "checklist",
    //   position: 5.1,
    //   roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS],
    // });
    // this.addSubMenu('checklist', {
    //   title: "Space Type Checklist",
    //   url: "checklist",
    //   position: 1,
    //   roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    // });

    this.addMenu({
      title: "Timesheet",
      url: "timelines",
      icon: this.getIcon("timelines"),
      key: "timelines",
      position: 4.1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER]
    });

    this.addSubMenu('timelines', {
      title: "Dashboard",
      url: "timelines/dashboard",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER]
    });

    this.addSubMenu('timelines', {
      title: "Timesheet",
      url: "timelines/time-sheet",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER]
    });

    this.addSubMenu('timelines', {
      title: "Amendments",
      url: "timelines/amendments",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER]
    });

    this.addSubMenu('timelines', {
      title: "Shift Override",
      url: "timelines/shift-override",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER]
    });

    // MFB
    // this.addMenu({
    //   title: "Miles For Bucks",
    //   url: "mfb",
    //   icon: this.getIcon("mfb"),
    //   key: "mfb",
    //   position: 5,
    //   roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS],
    // });
    // this.addSubMenu('mfb', {
    //   title: "Miles For Bucks",
    //   url: "mfb",
    //   position: 1,
    //   roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    // });

    // this.addSubMenu('mfb', {
    //   title: "Dashboard",
    //   url: "mfb/dashboard",
    //   position: 2,
    //   roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR,]
    // });

    // Fares
    this.addMenu({
      title: "Rates",
      url: "rates",
      icon: this.getIcon("fares"),
      key: "rates",
      position: 5,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS],
    });

    this.addSubMenu('rates', {
      title: "Rates",
      url: "rates",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    });
    this.addSubMenu("rates", {
      title: "Addons",
      url: "rates/addons",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    });

    this.addSubMenu('rates', {
      title: "Appointment Types",
      url: "rates/appointment-types",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS]
    });

    // Billing
    this.addMenu({
      title: "Billing",
      url: "billing",
      icon: this.getIcon("fares"),
      key: "billing",
      position: 5.1,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS],
    });


    this.addSubMenu('billing', {
      title: "TRFs & Claims",
      url: "billing/adjusted-trips",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.ACCOUNTANT]
    });

    this.addSubMenu('billing', {
      title: "TRFs Templates",
      url: "billing/trfs-templates",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.ACCOUNTANT]
    });

    this.addSubMenu("billing", {
      title: "Primary Diagnosis",
      url: "billing/primary-diagnosis",
      position: 3,
      roles: [UserRoles.ADMIN, UserRoles.FULLACCESS]
    });

    this.addSubMenu("billing", {
      title: "Modifier Codes",
      url: "billing/modifier-codes",
      position: 4,
      roles: [UserRoles.ADMIN, UserRoles.FULLACCESS]
    });
    this.addSubMenu('billing', {
      title: "EDI 835",
      url: "billing/edireports",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    });

    // Maintenance
    this.addMenu({
      title: "Maintenance",
      url: "maintenances",
      icon: this.getIcon("maintain"),
      key: "maintenances",
      position: 6.2,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR],
    });

    this.addSubMenu('maintenances', {
      title: "Driver Expense",
      url: "maintenances/driver-expense",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('maintenances', {
      title: "Vehicle Expense",
      url: "maintenances/vehicle-expense",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('maintenances', {
      title: "Statistics",
      url: "maintenances/maintenance-stats",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.DISPATCHER_RMNGR, UserRoles.CALL_CENTER_MNGR]
    });

    // Reports
    this.addMenu({
      title: "Reports",
      url: "reports",
      icon: this.getIcon("reports"),
      key: "reports",
      position: 6,
      roles: [UserRoles.COMPANY, UserRoles.ADMIN, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR],
    });
    this.addSubMenu('reports', {
      title: "Reports",
      url: "reports",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('reports', {
      title: "Business Reports",
      url: "reports/nemtreport",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('reports', {
      title: "Statistics",
      url: "reports/statistics",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.ACCOUNTANT, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('reports', {
      title: "Vehicle Inspection",
      url: "reports/vehicle-inspection",
      position: 3,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS]
    });

    this.addSubMenu('reports', {
      title: "Outbounding",
      url: "reports/outbounding",
      position: 3.1,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS]
    });

    this.addSubMenu('reports', {
      title: "Accidental Reports",
      url: "reports/accidental-report",
      position: 5,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS]
    });

    this.addSubMenu('reports', {
      title: "Grievance / Item Lost",
      url: "reports/drivergrievance",
      position: 5,
      roles: [UserRoles.COMPANY, UserRoles.CREDENTIAL, UserRoles.FULLACCESS]
    });

    this.addSubMenu('reports', {
      title: "Driver Score",
      url: "reports/driver-score",
      position: 5.1,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    });

    this.addSubMenu('reports', {
      title: "Driver Earnings",
      url: "reports/driver-earnings",
      position: 5.2,
      roles: [UserRoles.COMPANY, UserRoles.FULLACCESS, UserRoles.DISPATCHER_MNGR, UserRoles.CALL_CENTER_MNGR]
    });


    this.addSubMenu('reports', {
      title: "Reports",
      url: "reports/superadmin/nemtreport",
      position: 5,
      roles: [UserRoles.ADMIN]
    });

    this.addSubMenu('reports', {
      title: "Earnings",
      url: "reports/superadmin/earning",
      position: 6,
      roles: [UserRoles.ADMIN]
    });

    this.addMenu({
      title: "Invoice",
      url: "providerinvoicesettings",
      icon: this.getIcon("invoices"),
      key: "invoices",
      position: 8,
      roles: [UserRoles.ADMIN],
    });

    // Support
    this.addMenu({
      title: "Support",
      url: "support",
      icon: this.getIcon("support"),
      key: "support",
      position: 7,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR],
    });

    this.addSubMenu('support', {
      title: "Chats",
      url: "support/chats",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    });

    this.addSubMenu('support', {
      title: "Push to Talk",
      url: "support/push-to-talk",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS]
    });


    this.addMenu({
      title: "SMS",
      url: "sms/dashboard",
      icon: this.getIcon("sms"),
      key: "sms/dashboard",
      position: 8,
      roles: [UserRoles.FULLACCESS, UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR],
    });

    // guide
    this.addMenu({
      title: "Manual",
      url: "manual",
      icon: this.getIcon("help"),
      key: "manual",
      position: 7,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR],
    });

    this.addSubMenu('manual', {
      title: "Helping Material",
      url: "manual/helpingmaterial",
      position: 1,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    });

    this.addSubMenu('manual', {
      title: "Nemt Pro Tips",
      url: "manual/nemtprotips",
      position: 2,
      roles: [UserRoles.COMPANY, UserRoles.DISPATCHER, UserRoles.FULLACCESS, UserRoles.DISPATCHER_RMNGR, UserRoles.DISPATCHER_MNGR]
    });

    this.addMenu({
      title: "Pro Tips",
      url: "nemtprotips",
      icon: this.getIcon("protips"),
      key: "protips",
      position: 9,
      roles: [UserRoles.ADMIN],
    });

    this.addMenu({
      title: "Map View",
      url: "mapview",
      icon: this.getIcon("map"),
      key: "protips",
      position: 10,
      roles: [UserRoles.ADMIN],
    });

  }

  getIcon(menu) {
    switch (menu) {
      case "manifest":
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0112 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5" />
      </svg>
      `;
      case "home":
        return `<svg
          class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            fill="currentColor"
            d="M6 19v1q0 .425-.287.712Q5.425 21 5 21H4q-.425 0-.712-.288Q3 20.425 3 20v-8l2.1-6q.15-.45.538-.725Q6.025 5 6.5 5h11q.475 0 .863.275q.387.275.537.725l2.1 6v8q0 .425-.288.712Q20.425 21 20 21h-1q-.425 0-.712-.288Q18 20.425 18 20v-1Zm-.2-9h12.4l-1.05-3H6.85ZM5 12v5Zm2.5 4q.625 0 1.062-.438Q9 15.125 9 14.5t-.438-1.062Q8.125 13 7.5 13t-1.062.438Q6 13.875 6 14.5t.438 1.062Q6.875 16 7.5 16Zm9 0q.625 0 1.062-.438Q18 15.125 18 14.5t-.438-1.062Q17.125 13 16.5 13t-1.062.438Q15 13.875 15 14.5t.438 1.062Q15.875 16 16.5 16ZM5 17h14v-5H5Z"
          />
        </svg>`
      case 'help':
        return `<svg
          class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          >
          <path fill="currentColor"
          d="M14 8.775q0-.225.163-.463T14.524 8q.725-.25 1.45-.375T17.5 7.5q.5 0 .988.063t.962.162q.225.05.388.25t.162.45q0 .425-.275.625t-.7.1q-.35-.075-.737-.113T17.5 9q-.65 0-1.275.125t-1.2.325q-.45.175-.737-.025T14 8.775Zm0 5.5q0-.225.163-.463t.362-.312q.725-.25 1.45-.375T17.5 13q.5 0 .988.063t.962.162q.225.05.388.25t.162.45q0 .425-.275.625t-.7.1q-.35-.075-.737-.113T17.5 14.5q-.65 0-1.275.113t-1.2.312q-.45.175-.738-.013T14 14.276Zm0-2.75q0-.225.163-.463t.362-.312q.725-.25 1.45-.375t1.525-.125q.5 0 .988.063t.962.162q.225.05.388.25t.162.45q0 .425-.275.625t-.7.1q-.35-.075-.737-.113t-.788-.037q-.65 0-1.275.125t-1.2.325q-.45.175-.737-.025t-.288-.65ZM6.5 16q1.175 0 2.288.263T11 17.05V7.2q-1.025-.6-2.175-.9T6.5 6q-.9 0-1.788.175T3 6.7v9.9q.875-.3 1.738-.45T6.5 16Zm6.5 1.05q1.1-.525 2.212-.788T17.5 16q.9 0 1.763.15T21 16.6V6.7q-.825-.35-1.713-.525T17.5 6q-1.175 0-2.325.3T13 7.2v9.85Zm-6-5.4Zm5 7.825q-.35 0-.663-.088t-.587-.237q-.975-.575-2.05-.862T6.5 18q-1.05 0-2.063.275T2.5 19.05q-.525.275-1.012-.025T1 18.15V6.1q0-.275.138-.525T1.55 5.2q1.15-.6 2.4-.9T6.5 4q1.45 0 2.838.375T12 5.5q1.275-.75 2.663-1.125T17.5 4q1.3 0 2.55.3t2.4.9q.275.125.413.375T23 6.1v12.05q0 .575-.487.875t-1.013.025q-.925-.5-1.937-.775T17.5 18q-1.125 0-2.2.288t-2.05.862q-.275.15-.588.238t-.662.087Z"/></svg>`
      case 'protips':
        return `<svg
          class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24">
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
           d="M10 18v-.107c0-.795-.496-1.488-1.117-1.984a5 5 0 1 1 6.235 0c-.622.497-1.118 1.189-1.118 1.984V18m-4 0v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2m-4 0h4m6-6h1M4 12H3m9-8V3m5.657 3.343l.707-.707m-12.02.707l-.708-.707M12 15v-2"/></svg>`
      case 'operations':
        return `<svg
          class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
        >
        <path
          fill="currentColor"
          d="M24 21h2v5h-2zm-4-5h2v10h-2zm-9 10a5.006 5.006 0 0 1-5-5h2a3 3 0 1 0 3-3v-2a5 5 0 0 1 0 10z"
        />
        <path
          fill="currentColor"
          d="M28 2H4a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm0 9H14V4h14ZM12 4v7H4V4ZM4 28V13h24l.002 15Z"
        />
      </svg>`
      case 'trips':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M14.844 20H6.5C5.121 20 4 18.879 4 17.5S5.121 15 6.5 15h7c1.93 0 3.5-1.57 3.5-3.5S15.43 8 13.5 8H8.639a9.812 9.812 0 0 1-1.354 2H13.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5h-7C4.019 13 2 15.019 2 17.5S4.019 22 6.5 22h9.593a10.415 10.415 0 0 1-1.249-2zM5 2C3.346 2 2 3.346 2 5c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 5 6.5z"
        />
        <path
          fill="currentColor"
          d="M19 14c-1.654 0-3 1.346-3 3c0 3.188 3 5 3 5s3-1.813 3-5c0-1.654-1.346-3-3-3zm0 4.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 19 18.5z"
        />
      </svg>`
      case 'planner':
        return `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6 fill-current" viewBox="0 0 424.172 424.172"><path d="M383.75 229.503c0 3.555-.123 7.113-.357 10.66a79.379 79.379 0 0 1 29.305 9.366c.697-6.64 1.053-13.34 1.053-20.026 0-38.629-11.551-75.798-33.403-107.488-19.242-27.904-45.254-49.922-75.679-64.181a80.213 80.213 0 0 1-6.972 29.992c52.748 27.26 86.053 81.307 86.053 141.677zM151.572 87.429a80.199 80.199 0 0 1-6.8-30.076c-33.253 15.37-61.478 40.182-81.042 71.229a79.472 79.472 0 0 1 28.662 10.998 160.346 160.346 0 0 1 59.18-52.151zM308.387 365.065c-25.212 15.732-54.039 23.989-84.189 23.989a159.473 159.473 0 0 1-144.003-90.769l-20.314 25.79a189.435 189.435 0 0 0 164.317 94.979c36.886 0 72.112-10.408 102.703-30.21l-15.516-19.697a79.149 79.149 0 0 1-2.998-4.082zM224.725 135.877l39.221-49.791c7.058-8.925 10.779-19.625 10.779-30.968 0-27.57-22.43-50-50-50s-50 22.43-50 50c0 11.343 3.721 22.043 10.762 30.945l39.238 49.814zm0-95.664c8.219 0 14.905 6.686 14.905 14.905s-6.686 14.905-14.905 14.905-14.905-6.686-14.905-14.905 6.686-14.905 14.905-14.905zM100 207.378c0-27.57-22.43-50-50-50s-50 22.43-50 50c0 11.343 3.721 22.044 10.761 30.946L50 288.137l39.221-49.791C96.279 229.421 100 218.72 100 207.378zm-50 14.905c-8.219 0-14.905-6.687-14.905-14.905 0-8.219 6.686-14.905 14.905-14.905s14.905 6.686 14.905 14.905c0 8.218-6.687 14.905-14.905 14.905zM374.172 269.615c-27.57 0-50 22.43-50 50 0 11.343 3.721 22.043 10.762 30.945l39.238 49.813 39.221-49.791c7.058-8.925 10.779-19.625 10.779-30.968 0-27.569-22.43-49.999-50-49.999zm0 64.905c-8.219 0-14.905-6.686-14.905-14.905s6.686-14.905 14.905-14.905 14.905 6.686 14.905 14.905-6.686 14.905-14.905 14.905z"/></svg>`
      case 'credentialing':
        return `<svg class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32">
        <path fill="currentColor" d="M16 22a4 4 0 1 0-4-4a4 4 0 0 0 4 4zm0-6a2 2 0 1 1-2 2a2 2 0 0 1 2-2zM14 6h4v2h-4z" />
        <path fill="currentColor"
          d="M24 2H8a2.002 2.002 0 0 0-2 2v24a2.002 2.002 0 0 0 2 2h16a2.003 2.003 0 0 0 2-2V4a2.002 2.002 0 0 0-2-2Zm-4 26h-8v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Zm2 0v-2a3 3 0 0 0-3-3h-6a3 3 0 0 0-3 3v2H8V4h16v24Z" />
      </svg>`
      case 'fleet':
        return `<svg id="Layer_1" class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6" data-name="Layer 1" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 53.49"><defs><style>.cls-1{fill-rule:evenodd;}</style></defs><title>cars</title><path class="cls-1" d="M93.43.94h13c4,0,6.3,3.39,7.27,7.27L116,17.62l1.34-2.54c6.95-.4,7.57,3.64.22,7.12L118.78,24c4.84,5,4.38,9.93,3.63,22.21v4a2.27,2.27,0,0,1-2.27,2.27h-9.71a2.27,2.27,0,0,1-2.27-2.27V48.45h-3.6V47l0-.63c.18-2.92.34-5.49.42-7.79l5.73-.05a3.88,3.88,0,0,0,1.93-.53,3.3,3.3,0,0,0,1.17-1.3l.93-2.26c.69-1.76.14-2.61-1.89-2.39L105,33a19.87,19.87,0,0,0-2.65-9.45,11.6,11.6,0,0,0,1.4-1.91h0a10.55,10.55,0,0,0,.73-1.57h8.14l-2.35-9.76c-.64-3-2.49-5.55-5.55-5.55H95A21.78,21.78,0,0,0,93.43.94ZM31.27,21.74c-7-3.54-6.17-7.49.83-7.08l1.57,2.94,3.23-10C38.17,3.59,40.29,0,44.44,0H81c4.15,0,6.53,3.52,7.54,7.54L91,17.29l1.4-2.63c7.2-.42,7.85,3.77.22,7.38l1.24,1.9c5,5.15,4.54,10.29,3.76,23v4.18a2.36,2.36,0,0,1-2.35,2.36H85.17a2.36,2.36,0,0,1-2.35-2.36V49.24H40.08v1.89a2.36,2.36,0,0,1-2.36,2.36h-10a2.36,2.36,0,0,1-2.36-2.36V45.7c0-.12,0-.24,0-.37-.76-9.76-1.84-18.56,5.93-23.59ZM44.11,33.32l-8.93-1.13c-2.11-.23-2.68.66-2,2.47l1,2.35a3.36,3.36,0,0,0,1.2,1.34,4.09,4.09,0,0,0,2,.56l8,.06c1.92,0,2.75-.77,2.15-2.54a4.3,4.3,0,0,0-3.4-3.11Zm34.67,0,8.93-1.13c2.1-.23,2.67.66,2,2.47L88.7,37a3.38,3.38,0,0,1-1.21,1.34,4.06,4.06,0,0,1-2,.56l-8,.06c-1.93,0-2.76-.77-2.16-2.54a4.31,4.31,0,0,1,3.41-3.11ZM37,19.82H87.38L85,9.7C84.28,6.62,82.36,4,79.2,4H45.81C42.65,4,41,6.69,40.06,9.7L37,19.82v0ZM32.15.94H16.47c-4,0-6.3,3.39-7.27,7.27L6.85,17.62,5.51,15.08c-6.95-.4-7.57,3.64-.22,7.12L4.1,24C-.74,29-.29,34,.47,46.25v4a2.27,2.27,0,0,0,2.27,2.27h9.71a2.27,2.27,0,0,0,2.27-2.27V48.45h3.62V45.36l-.06-.74c-.16-2.08-.33-4.11-.42-6.09l-5.73-.05A3.88,3.88,0,0,1,10.21,38,3.3,3.3,0,0,1,9,36.65l-.93-2.26C7.42,32.63,8,31.78,10,32l7.88,1a21.93,21.93,0,0,1,3.19-10.85c-.17-.25-.31-.5-.45-.74A11.35,11.35,0,0,1,20,20.06h-9.7l2.35-9.76c.64-3,2.49-5.55,5.55-5.55h12.3A26.67,26.67,0,0,1,32.15.94Z"/></svg>`
      case 'timelines':
        return `<svg class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>`
      case 'maintain':
        return `<svg xmlns="http://www.w3.org/2000/svg"
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        viewBox="0 0 24 24">
        <path fill="none" stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round" stroke-width="1.5"
        d="M11.42 15.17L17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437l1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z"/>
        </svg>`
      case 'fares':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 010 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 010-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375z"
        />
      </svg>`
      case 'reports':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z"
        />
      </svg>`
      case 'quarters':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
         xmlns="http://www.w3.org/2000/svg"
         fill="none"
         viewBox="0 0 24 24"
         stroke-width="1.5"
         stroke="currentColor"
         >
        <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25"
        />
      </svg>`
      case 'invoices':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 48 48"><g fill="none"
         stroke="currentColor"
         stroke-width="4"
         >
         <path
         stroke-linecap="round"
         stroke-linejoin="round"
         d="M24 6H9a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3v-5m-18 8v8m-10 0h20"/><circle cx="37" cy="13" r="3"/><path stroke-linecap="round" stroke-linejoin="round" d="M37 20v-4m0-6V6m-6.062 10.5l3.464-2m5.196-3l3.464-2m-12.124 0l3.464 2m5.196 3l3.464 2"
         /></g>
         </svg>`
      case 'support':
        return `<svg
        class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
        />
      </svg>`

      case 'sms':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z" />
      </svg>
      `

      case 'map':
        return `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
          </svg>
        `
      case 'mfb':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.08 20.162L10 14l-7-3.5a.55.55 0 0 1 0-1L21 3l-2.55 7.063M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H17m2 0v1m0-8v1"/></svg>
      `
      case 'checklist':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.048 2.488a.75.75 0 0 1-.036 1.06l-4.286 4a.75.75 0 0 1-1.095-.076l-1.214-1.5a.75.75 0 0 1 1.166-.944l.708.875l3.697-3.451a.75.75 0 0 1 1.06.036M11.25 5a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75M8.048 9.488a.75.75 0 0 1-.036 1.06l-4.286 4a.75.75 0 0 1-1.095-.076l-1.214-1.5a.75.75 0 1 1 1.166-.944l.708.875l3.697-3.451a.75.75 0 0 1 1.06.036M11.25 12a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m-3.202 4.488a.75.75 0 0 1-.036 1.06l-4.286 4a.75.75 0 0 1-1.095-.076l-1.214-1.5a.75.75 0 1 1 1.166-.944l.708.875l3.697-3.451a.75.75 0 0 1 1.06.036M11.25 19a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75" clip-rule="evenodd"/></svg>`
      case 'farmout':
        return `<svg xmlns="http://www.w3.org/2000/svg" class="text-nav-svg-dark group-hover:text-nav-light h-6 w-6" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2m8-16h2a2 2 0 0 1 2 2v2m-4 12h2a2 2 0 0 0 2-2v-2M7 12V9h3m4 0h3v3"/><path d="m7 9l4.414 4.414A2 2 0 0 1 12 14.828V17m5-8l-4.414 4.414A2 2 0 0 0 12 14.828V17"/></g></svg>`
      default:
        return '<svg class="navbar-svg-default mr-4 flex-shrink-0 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" /></svg>';
    }
  }

  canView(menuRoles) {
    if (Array.isArray(this.userRole)) {
      // In case if user has multiple roles assigned to them.
      // Logic will be added here if needed.
      return false;
    }

    return menuRoles.includes(this.userRole);
  }

  getUserRoleTitle(role) {
    let title = '';
    if (role === UserRoles.DISPATCHER_RMNGR) {
      title = "Restricted (RM,SM,ASM)";
    } else if (role === UserRoles.DISPATCHER_MNGR) {
      title = "Dispatcher Manager";
    } else if (role === UserRoles.CALL_CENTER_MNGR) {
      title = "Call Center Manager";
    } else if (role === UserRoles.CALL_CENTER_REP) {
      title = "Call Center Representative";
    } else if (role === UserRoles.FULLACCESS) {
      title = "Full Access";
    } else {
      title = role;
    }

    return title;
  }
}
